import { createAction } from '@reduxjs/toolkit';

import type { CardsTypes } from '@modules';
import api from '@modules/api';
import { createAsyncActions, createActions } from '@modules/helpers';

import { getFingerPrint3DS, getFingerPrintAntifraud } from '@selectors';

import type { CardsStateType } from './state';

const actions = createActions('cards', {
  setCard: name => createAction<{ name: keyof CardsStateType['card']; value: string }>(name),

  setCardId: name => createAction<string | undefined>(name),

  set3DSPassed: name => createAction<boolean>(name),

  clearRedirect: name => createAction(name),

  resetBindCardState: name => createAction(name),

  clearError: name => createAction<string>(name),

  clearAllErrors: name => createAction(name),

  resetCardData: name => createAction<void>(name),
});

export const asyncActions = createAsyncActions('cards', {
  getCards: (_: void, thunkApi) => api.get<CardsTypes.GETCardsResponse[]>(thunkApi, '/cards'),

  bind: (data: CardsTypes.POSTCardsBindParams, thunkApi) => {
    const { global } = thunkApi.getState();
    const { fingerPrintData } = global;

    return api.post<CardsTypes.POSTCardsBindResponse>(thunkApi, '/cards/bind', {
      ...data,
      redirect_url: `${CONST.card3dsDomain}?${CONST.card3DS.cardReturnParam}={binding_id}`,
      ...getFingerPrint3DS(fingerPrintData),
      ...getFingerPrintAntifraud(fingerPrintData),
    });
  },

  getBindStatus: (id: string, thunkApi) =>
    api.get<CardsTypes.GETCardsBindStatusResponse>(thunkApi, `/cards/${id}/bind-status`),

  getBindStatusPolling: (id: string, thunkApi) =>
    api.get<CardsTypes.GETCardsBindStatusResponse>(thunkApi, `/cards/${id}/bind-status`),

  deleteCard: (data: CardsTypes.POSTCardsDeleteParams, thunkApi) =>
    api.post(thunkApi, `/cards/${data.id}/delete`),

  flutterwaveValidate: (data: CardsTypes.FlutterWaveValidateParams, thunkApi) =>
    api.post<CardsTypes.FlutterWaveValidateResponse>(thunkApi, '/flutterwave/validate', data),
});

export default { ...actions, ...asyncActions };
